/**
 * Button — matches the prototype's .btn / .btn-primary / .btn-secondary /
 * .btn-pill / .btn-sm variants. British English project.
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './Button.css';

type Variant = 'primary' | 'secondary' | 'danger';
type Size = 'default' | 'sm';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  pill?: boolean;
  size?: Size;
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  pill = false,
  size = 'default',
  loading = false,
  disabled,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const classes = [
    'itk-btn',
    `itk-btn--${variant}`,
    pill ? 'itk-btn--pill' : '',
    size === 'sm' ? 'itk-btn--sm' : '',
    loading ? 'itk-btn--loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading && <span className="itk-btn__spin" aria-hidden="true" />}
      <span className="itk-btn__lbl">{children}</span>
    </button>
  );
}